/**
 * @generated SignedSource<<b230097589a880233d45b9cae7f90879>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type useInitializeLessonBookingWizardNode$data = {
  readonly allStartSlodIds?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly firstStartSlot?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly agenda: {
          readonly date: string;
          readonly facility: {
            readonly club: {
              readonly supportsPrivate: boolean;
            } | null | undefined;
            readonly id: string;
            readonly minMaxGroupSize: {
              readonly max: number | null | undefined;
              readonly min: number | null | undefined;
            } | null | undefined;
            readonly name: string;
            readonly privateLessonsPermissionSet: {
              readonly patronAccess: LessonAccess | null | undefined;
              readonly patronSelectVenue: boolean | null | undefined;
            } | null | undefined;
            readonly publicLessonsPermissionSet: {
              readonly patronAccess: LessonAccess | null | undefined;
              readonly patronSelectVenue: boolean | null | undefined;
              readonly prePaymentRequirement: PrePaymentRequirement | null | undefined;
              readonly requirePaymentCardOnFile: boolean | null | undefined;
            } | null | undefined;
          };
          readonly queueSlot: {
            readonly id: string;
          };
        };
        readonly capacity: number;
        readonly course: {
          readonly id: string;
        };
        readonly id: string;
        readonly usedCapacity: number;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id?: string;
  readonly " $fragmentType": "useInitializeLessonBookingWizardNode";
};
export type useInitializeLessonBookingWizardNode$key = {
  readonly " $data"?: useInitializeLessonBookingWizardNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeLessonBookingWizardNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "bookingType",
  "value": "LESSON"
},
v2 = {
  "kind": "Variable",
  "name": "lessonTypeId",
  "variableName": "lessonTypeId"
},
v3 = {
  "fields": [
    (v1/*: any*/),
    {
      "kind": "Variable",
      "name": "facilityId",
      "variableName": "facilityId"
    },
    (v2/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "slotAvailability"
},
v4 = [
  (v0/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patronSelectVenue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patronAccess",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "facilityId"
    },
    {
      "kind": "RootArgument",
      "name": "lessonTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeLessonBookingWizardNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": "firstStartSlot",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            (v3/*: any*/)
          ],
          "concreteType": "TimeSlotConnection",
          "kind": "LinkedField",
          "name": "startSlots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": [
                        (v1/*: any*/),
                        (v2/*: any*/)
                      ],
                      "kind": "ScalarField",
                      "name": "capacity",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "usedCapacity",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Course",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": (v4/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Agenda",
                      "kind": "LinkedField",
                      "name": "agenda",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "date",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "QueueSlot",
                          "kind": "LinkedField",
                          "name": "queueSlot",
                          "plural": false,
                          "selections": (v4/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Facility",
                          "kind": "LinkedField",
                          "name": "facility",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Club",
                              "kind": "LinkedField",
                              "name": "club",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "supportsPrivate",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PrivateLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "privateLessonsPermissionSet",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/),
                                (v6/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PublicLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "publicLessonsPermissionSet",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/),
                                (v6/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "requirePaymentCardOnFile",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "prePaymentRequirement",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": [
                                (v1/*: any*/)
                              ],
                              "concreteType": "GroupSize",
                              "kind": "LinkedField",
                              "name": "minMaxGroupSize",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "min",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "max",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": "minMaxGroupSize(bookingType:\"LESSON\")"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "allStartSlodIds",
          "args": [
            (v3/*: any*/)
          ],
          "concreteType": "TimeSlotConnection",
          "kind": "LinkedField",
          "name": "startSlots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AvailabilitySlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "45c14e22469d8e37cd6f9df2ff2b55a5";

export default node;
